<template>
  <b-dropdown aria-role="list">
    <template #trigger>
      <div id="header-profile">
        <div class="profile-icon-container">
          <b-image class="profile-icon" :src="photoURL" rounded ratio="1by1" />
        </div>
        <div class="profile-info">
          <p>{{ nickname }} さん</p>
          <div class="point">
            <p>{{ doronAmount }} ドロン</p>
          </div>
        </div>
      </div>
    </template>
    <b-dropdown-item
      v-if="isPerformer && !isStreaming"
      aria-role="menuitem"
      href="/live/menu"
    >
      配信する
    </b-dropdown-item>
    <b-dropdown-item
      v-if="isPerformer && isStreaming"
      aria-role="menuitem"
      :href="`/live/console/${recentLiveId}`"
      id="live-console-menu-item"
    >
      <b-icon icon="monitor"></b-icon>
      配信中のライブ
    </b-dropdown-item>
    <b-dropdown-item
      aria-role="menuitem"
      :href="isPerformer ? '/mypage/performer' : '/mypage'"
    >
      マイページ
    </b-dropdown-item>
    <b-dropdown-item aria-role="menuitem" href="/doron/purchase">
      ドロン購入
    </b-dropdown-item>
    <b-dropdown-item aria-role="menuitem" @click="signOut">
      サインアウト
    </b-dropdown-item>
  </b-dropdown>
</template>

<script>
import { auth } from '@/plugins/firebase';
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'HeaderProfile',
  created() {
    this.$store.dispatch('user/loadUserDoc');
  },
  computed: {
    ...mapGetters('user', ['isStreaming', 'isPerformer', 'recentLiveId']),
    ...mapGetters('doron', ['doronAmount']),
    ...mapState('user', ['nickname']),
    defaultPhotoURL() {
      return 'https://firebasestorage.googleapis.com/v0/b/pandora-988f8.appspot.com/o/all%2Fdefault-user-icon.png?alt=media&token=4a1a4307-1990-4c99-a944-9b8d289e1a50';
    },
    photoURL() {
      return this.$store.state.user.photoURL || this.defaultPhotoURL;
    }
  },
  methods: {
    async signOut() {
      await auth.signOut().catch(err => {
        console.log(err);
      });
      this.$store.dispatch('auth/signOut');
      this.$router.push('/signin');
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../assets/scss/header-profile.scss';
</style>
